/* Quiz "Encontre sua camiseta ideal" — sections/quiz-camiseta-ideal.liquid
   Delegação de eventos no document (sem <script> inline): funciona mesmo se a seção
   for re-renderizada pelo editor de temas. Cards e carrinho: assets/tecidos-minimal.js. */
(function () {
  if (window.__quizCamisetaIdeal) return;
  window.__quizCamisetaIdeal = true;

  var states = new WeakMap();
  function state(root) {
    var st = states.get(root);
    if (!st) { st = { step: -1, answers: [] }; states.set(root, st); }
    return st;
  }
  function questions(root) { return root.querySelectorAll('[data-qc-screen="q"]'); }

  function show(root, step, scroll) {
    var st = state(root);
    var total = questions(root).length;
    st.step = step;
    root.querySelectorAll('[data-qc-screen]').forEach(function (el) {
      var kind = el.getAttribute('data-qc-screen');
      el.hidden = !(
        (kind === 'intro' && step === -1) ||
        (kind === 'q' && parseInt(el.getAttribute('data-qc-q'), 10) === step) ||
        (kind === 'results' && step >= total)
      );
    });
    var stage = root.querySelector('[data-qc-stage]');
    stage.classList.toggle('is-results', step >= total);
    stage.classList.toggle('is-intro', step === -1);
    if (step >= 0 && step < total) markSelected(root, step);
    if (step >= total) renderResults(root);
    if (scroll) {
      var top = stage.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.4) {
        window.scrollTo({ top: window.pageYOffset + top - 80, behavior: 'smooth' });
      }
    }
  }

  function markSelected(root, step) {
    var ans = state(root).answers[step];
    var screen = questions(root)[step];
    screen.querySelectorAll('[data-qc-option]').forEach(function (btn, i) {
      btn.classList.toggle('is-selected', !!ans && ans.index === i);
    });
  }

  /* Tecido recomendado: o mais apontado nas respostas; empate → o da resposta que veio
     primeiro (ex.: "esquenta" na 1ª pergunta já puxa o tecido de treino, como na FCT). */
  function recommendedFabric(root) {
    var valid = {};
    root.querySelectorAll('[data-qc-fabric]').forEach(function (f) { valid[f.getAttribute('data-qc-fabric')] = true; });
    var count = {}, order = [];
    state(root).answers.forEach(function (a) {
      if (!a || !a.tecido || !valid[a.tecido]) return;
      if (!count[a.tecido]) order.push(a.tecido);
      count[a.tecido] = (count[a.tecido] || 0) + 1;
    });
    var best = null;
    order.forEach(function (t) { if (!best || count[t] > count[best]) best = t; });
    if (!best) {
      var first = root.querySelector('[data-qc-fabric]');
      best = first && first.getAttribute('data-qc-fabric');
    }
    return best;
  }

  /* Mesma lógica da FCT: cada resposta traz ~total/nº de respostas peças do seu tecido;
     "peça avulsa" (FCT: "try one first") traz 1 a mais, e outra resposta cede 1, para o
     total ficar fechado. Sem repetir produto. Diferença: o formato escolhido (kit/avulsa)
     vale como preferência para o resultado todo — nossos tecidos têm poucas peças cada,
     e sem isso "Testar uma primeiro" acabava mostrando kits de outro tecido. Faltando
     peças, completa com o tecido recomendado e depois com os outros (ordem dos blocos). */
  function pick(root, rec) {
    var pool = [].slice.call(root.querySelectorAll('[data-qc-item]'));
    var total = parseInt(root.getAttribute('data-qc-total'), 10) || 6;
    var answers = state(root).answers.filter(Boolean);
    var per = Math.max(1, Math.floor(total / Math.max(1, answers.length)));
    var pref = '';
    answers.forEach(function (a) { if (a.formato) pref = a.formato; });
    var hasSingle = pref === 'avulsa';
    var trimmed = false, seen = {}, picks = [];

    // passes: formatos aceitos, em ordem ('' = qualquer)
    function take(tecido, passes, n) {
      var added = 0;
      passes.forEach(function (f) {
        for (var i = 0; i < pool.length && added < n && picks.length < total; i++) {
          var el = pool[i], h = el.getAttribute('data-handle');
          if (seen[h] || (tecido && el.getAttribute('data-tecido') !== tecido)) continue;
          if (f && el.getAttribute('data-formato') !== f) continue;
          seen[h] = true; picks.push(el); added++;
        }
      });
    }

    answers.forEach(function (a) {
      var n = per;
      if (a.formato === 'avulsa') n = per + 1;
      else if (hasSingle && !trimmed) { n = per - 1; trimmed = true; }
      take(a.tecido || rec, [a.formato || pref], n);
    });
    if (pref) { take(rec, [pref], total); take('', [pref], total); }
    take(rec, [''], total);
    take('', [''], total);
    return picks;
  }

  function renderResults(root) {
    var rec = recommendedFabric(root);
    var fabricEl = null;
    root.querySelectorAll('[data-qc-fabric]').forEach(function (f) {
      var on = f.getAttribute('data-qc-fabric') === rec;
      f.hidden = !on;
      if (on) fabricEl = f;
    });
    var shop = root.querySelector('[data-qc-shop]');
    if (shop) {
      if (!shop.hasAttribute('data-default-href')) shop.setAttribute('data-default-href', shop.getAttribute('href'));
      var link = fabricEl && fabricEl.getAttribute('data-qc-link');
      shop.setAttribute('href', link || shop.getAttribute('data-default-href'));
    }
    var grid = root.querySelector('[data-qc-grid]');
    var pool = root.querySelector('[data-qc-pool]');
    // Devolve os cards da rodada anterior ao banco (mesmo nó: o card continua funcionando).
    [].slice.call(grid.children).forEach(function (el) { pool.appendChild(el); });
    var items = pick(root, rec);
    items.forEach(function (el) { grid.appendChild(el); });
    // Mantém a ordem original do banco para a próxima rodada.
    [].slice.call(pool.children)
      .sort(function (a, b) { return a.__qcIndex - b.__qcIndex; })
      .forEach(function (el) { pool.appendChild(el); });
  }

  function init() {
    document.querySelectorAll('[data-qc]').forEach(function (root) {
      root.querySelectorAll('[data-qc-item]').forEach(function (el, i) {
        if (el.__qcIndex == null) el.__qcIndex = i;
      });
      show(root, state(root).step, false);
    });
  }

  document.addEventListener('click', function (e) {
    var root = e.target.closest && e.target.closest('[data-qc]');
    if (!root) return;
    var st = state(root);

    if (e.target.closest('[data-qc-start]')) { st.answers = []; show(root, 0, true); return; }

    var opt = e.target.closest('[data-qc-option]');
    if (opt) {
      var screen = opt.closest('[data-qc-screen="q"]');
      var step = parseInt(screen.getAttribute('data-qc-q'), 10);
      var opts = [].slice.call(screen.querySelectorAll('[data-qc-option]'));
      st.answers[step] = {
        index: opts.indexOf(opt),
        tecido: opt.getAttribute('data-tecido') || '',
        formato: opt.getAttribute('data-formato') || ''
      };
      markSelected(root, step);
      if (root.__qcTimer) clearTimeout(root.__qcTimer);
      // pausa curta para a escolha aparecer antes de avançar (igual à FCT)
      root.__qcTimer = setTimeout(function () { show(root, step + 1, true); }, 250);
      return;
    }

    if (e.target.closest('[data-qc-prev]')) { show(root, Math.max(0, st.step - 1), true); return; }

    if (e.target.closest('[data-qc-reset]')) { st.answers = []; show(root, -1, true); }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
